<div class="tag-header">
  <div class="title-line mb-4">
    <rk-icon-button
      (click)="goBackToLast()"
      [bordered]="true"
      [size]="24"
      faIcon="fa-arrow-left"
    ></rk-icon-button>
    <h1 class="font-bold md:font-normal text-black text-2xl md:text-1.5xl truncate">
      {{ tag.name }}
    </h1>
    <span class="tag-color" [style.backgroundColor]="tag.color"></span>
  </div>
  <div class="tag-actions">
    <rk-button
      [label]="'MEDIA.TAGS.EDIT' | translate"
      [faIcon]="'fa-pen'"
      (click)="startEditTag()"
    ></rk-button>
    <rk-button
      [btnStyle]="'orange'"
      [matMenuTriggerFor]="tableMenu"
      [svgIcon]="'dot-down'"
      (click)="placeMatMenu()"
    ></rk-button>
  </div>
  <div class="tag-length-search flex justify-between items-end">
    <div class="tag-length">
      <ng-container *ngIf="!currentSearchValue; else filtering">
        <span>
          {{ 'MEDIA.PLAYLIST.NB_TRACKS' | translate : { tracks: totalTracks } }}
        </span>
        -
        <span translate [translateParams]="getMinutesAndHours(tracksTime$ | async)"
          >MEDIA.BACS.TIME</span
        >
      </ng-container>
    </div>
    <div class="search">
      <rk-search-bar #searchBar (inputted)="onSearchInput($event)"></rk-search-bar>
    </div>
  </div>
</div>
<ng-template #filtering>
  <span
    class="filtering"
    [innerHTML]="
      'MEDIA.PLAYLIST.FILTERING'
        | translate : { displayed: displayedTracks || 0, total: totalTracks }
    "
  ></span>
</ng-template>

<mat-menu #tableMenu="matMenu" [overlapTrigger]="false">
  <ng-container>
    <button mat-menu-item (click)="deleteTag()">
      <mat-icon fontSet="fa" fontIcon="fa-trash"></mat-icon>
      <span translate>MEDIA.TAGS.DELETE</span>
    </button>
  </ng-container>
</mat-menu>
